// extracted by mini-css-extract-plugin
export var button = "_jf-0";
export var donut = "_jf-1";
export var donutFill = "_jf-3";
export var donutTrack = "_jf-2";